







import Vue from 'vue'

interface Props {
  imgSrc: string
  imgTitle: string
}

export default Vue.extend<{}, {}, {}, Props>({
  props: {
    imgSrc: {
      required: true,
    },
    imgTitle: {
      required: true,
    },
  },
})
